module.exports = require('./helpers/bundle-url').getBundleURL('f0Cf5') + "logo-dark.eefe0b7f.svg";